// A real street address: a number and street, a city, a state and a ZIP. A place name may come first (Mapbox "Hotel, 1 Main St, ...").
// The database repeats this rule (public.m19f_real_address, migration 289). No third-party imports: the client app builds this too.
const REAL_ADDRESS = /^(.*,\s*)?\d+[A-Za-z]?\s+[^,]*[A-Za-z][^,]*,\s*[^,]+,\s*[A-Za-z][A-Za-z .]+\s+\d{5}(-\d{4})?(\s*,\s*(USA|U\.S\.A\.|US|United States))?$/i;

export const isRealAddress = (value) => REAL_ADDRESS.test(String(value || '').trim());

/** "1 Main St", "Atlanta", "GA", "30303" -> one line, or '' until all four are filled in. */
export function composeAddress({ street = '', city = '', state = '', zip = '' } = {}) {
    const parts = [street, city, state, zip].map((v) => String(v).trim());
    if (parts.some((v) => !v)) return '';
    return `${parts[0]}, ${parts[1]}, ${parts[2]} ${parts[3]}`;
}
